import { EntityDocfile } from "../../entity/EntityDocfile";

export class DtoDocfilesPutRes extends EntityDocfile {}
